import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiBaseUrl } from '../../config/config';

const ApiStatus = () => {
  const [status, setStatus] = useState('checking');
  const [apiUrl, setApiUrl] = useState('');

  useEffect(() => {
    const baseUrl = getApiBaseUrl();
    setApiUrl(baseUrl);

    const checkApiStatus = async () => {
      try {

        await axios.get(`${baseUrl}/`);
        setStatus('connected');
      } catch (error) {
        setStatus('disconnected');
      }
    };

    checkApiStatus();


    const interval = setInterval(checkApiStatus, 30000);

    return () => clearInterval(interval);
  }, []);

  if (status === 'checking') {
    return (
      <div className="api-status api-status-checking">
        <small>
          <i className="fas fa-circle-notch fa-spin me-1"></i>
        </small>
      </div>
    );
  }

  if (status === 'connected') {
    return (
      <div className="api-status api-status-connected" title={`متصل بـ: ${apiUrl}`}>
        <small>
          <i className="fas fa-circle text-success me-1"></i>
        </small>
      </div>
    );
  }

  return (
    <div className="api-status api-status-disconnected" title={`فشل الاتصال بـ: ${apiUrl}`}>
      <small>
        <i className="fas fa-circle text-danger me-1"></i>
      </small>
    </div>
  );
};

export default ApiStatus;
